export default __webpack_public_path__ + "static/media/v480.2b1cc60d.m4v";